import { render, staticRenderFns } from "./device-template.vue?vue&type=template&id=59b75445&"
import script from "./device-template.vue?vue&type=script&lang=js&"
export * from "./device-template.vue?vue&type=script&lang=js&"
import style0 from "./device-template.vue?vue&type=style&index=0&id=59b75445&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports